<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">课程问题</li>
      </ul>
      <router-link :to="{ path: '/member/answer' }" class="go-back">
        <div><Icon type="ios-arrow-dropleft" size="20" />返回</div>
      </router-link>
    </div>
    <div class="member-main-body">
      <div class="main-header"></div>
      <div class="main-table scroll-top">
        <table>
          <thead>
            <tr>
              <th>课程</th>
              <th style="width: 300px">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataList" :key="index">
              <td>
                「{{ item.courseId }}」{{ item.courseName }}
                <span class="color2">[{{ item.courseType }}]</span>
              </td>
              <td class="right">
                <router-link
                  :to="{
                    name: 'AnswerList',
                    query: { s: state, t: 2, d: date, cid: item.courseId },
                  }"
                >
                  <span class="color2">{{ item.pptCount }}</span>
                  条视频提问 </router-link
                >|
                <router-link
                  :to="{
                    name: 'AnswerList',
                    query: { s: state, t: 1, d: date, cid: item.courseId },
                  }"
                >
                  <span class="color2">{{ item.exerCount }}</span>
                  条练习提问
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      state: 0,
      date: "",
      query: {
        agencyId: -1,
        isResolved: 0, //是否回答
        isReport: 0, //是否待详解
        isComment: 0, //是否有追问
        courseIds: "",
        datetime: "",
        userId: 0,
      },
      dataList: [],
    };
  },
  mounted() {
    this.setMetaData("我的答疑");
    if (!this.initParam()) return;
    this.getData();
  },
  methods: {
    initParam() {
      this.query.agencyId =
        this.siteConfig.agencyId > 0 ? this.siteConfig.agencyId : -1;
      const state = this.$route.query.t;
      const date = this.$route.query.d;
      if (typeof state != "undefined" && state >= 0 && state <= 3 && date) {
        this.query.isResolved = state == 0 ? 0 : 1;
        this.query.isReport = state == 2 ? 1 : 0;
        this.query.isComment = state == 3 ? 1 : 0;
        this.query.datetime = date;
        if (this.siteConfig.agencyId == 0) {
          let courseIds = "";
          this.userCourseList.forEach((item) => {
            if (courseIds) courseIds += ",";
            courseIds += item.courseId;
          });
          this.query.courseIds = courseIds;
        }
        this.query.userId = this.loginUser.userId;

        this.state = state;
        this.date = date;
        return true;
      } else {
        this.$Message.error("参数错误");
        return false;
      }
    },
    getData() {
      user.getQuestionListWithCourse(this.query).then((res) => {
        //console.log("courseQuestionList", res);
        if (res.status === 1) {
          this.dataList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";

.go-back {
  color: #0e90d2;
  font-size: 16px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  i {
    vertical-align: -0.2em;
    margin-right: 3px;
  }
}
</style>